// requires: sweetalert/sweetalert.min.js

var st_loader = {
    // Toggle Loading modal
    toggle: function () {
        if (jQuery('.swal-overlay--show-modal').length > 0) {
            swal.close();
        } else {
            swal({
                title: "Processing, Please wait...",
                buttons: false,
                closeOnClickOutside: false,
                className: "st-modal"
            });
        }
    }
};

jQuery(document).ready(function () {
    jQuery(document).on('click', ".st-funnel-yes a, .st-funnel-no a, a.st-funnel-yes, a.st-funnel-no", function (e) {
        st_loader.toggle();
    });
});